import styled from 'styled-components';

export const DestructiveButtonContainer = styled.button`
  box-sizing: border-box;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-xs);

  flex: 0 0 auto;

  width: auto;
  min-width: 120px;
  max-width: 260px;

  padding: var(--space-xs) var(--space-s);

  min-height: 36px;
  height: auto;

  border: 1px solid rgba(208, 17, 36, 0.18);
  border-radius: var(--borderRadiusButton);

  background: rgba(208, 17, 36, 0.06);

  color: var(--errorRed);

  font-size: 0.8rem;
  font-weight: 650;
  line-height: 1.1;
  letter-spacing: 0.02em;

  text-transform: capitalize;
  text-align: center;

  white-space: normal;

  cursor: pointer;

  box-shadow: none;

  transition:
    background 0.18s ease,
    border-color 0.18s ease,
    color 0.18s ease,
    box-shadow 0.18s ease,
    transform 0.16s ease;

  &:hover:not(:disabled) {
    background: rgba(208, 17, 36, 0.1);
    border-color: rgba(208, 17, 36, 0.28);

    transform: translateY(-1px);

    box-shadow: 0 6px 16px rgba(208, 17, 36, 0.1);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
    box-shadow: none;
  }

  &:disabled {
    background: var(--grey15);
    border-color: var(--grey1);
    color: var(--grey3);

    opacity: 0.7;
    cursor: not-allowed;

    box-shadow: none;
    transform: none;
  }

  &:focus-visible {
    outline: 3px solid rgba(208, 17, 36, 0.35);
    outline-offset: 3px;
  }

  @media (max-width: 768px) {
    padding: var(--space-xs) var(--space-s);

    font-size: var(--space-m);

    max-width: 60vw;
    min-height: 34px;
  }

  @media (max-width: 480px) {
    max-width: 90vw;
    min-height: 32px;
  }
`;
